import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography, makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => ({
  label: {
    lineHeight: '1.5em',
  },
}));

const NoProcessBox = ({ label }) => (
  <Grid item xs={12}>
    <Box px={5} pt={3} pb={1} width="100%" display="flex" flexDirection="column" alignItems="center">
      <Typography className={useStyles().label} variant="overline" align="center">
        {label || 'No se ha procesado el área de interés'}
      </Typography>
    </Box>
  </Grid>
);

NoProcessBox.propTypes = {
  label: PropTypes.string,
};


export {
  NoProcessBox,
};